const getTotalRequestRescheduleResponse = (response) => {
  return {
    ...response,
    remaining: response.maxRequest - response.total,
  };
};

export default getTotalRequestRescheduleResponse;
